import React from 'react';
import {
    FaCheckCircle,
    FaTimesCircle,
    FaSpinner
} from 'react-icons/fa';
import styles from '../styles/SubmissionDialog.module.css';

function SubmissionDialog({
                              isOpen,
                              status = 'success',
                              onClose,
                              title,
                              message
                          }) {
    const renderIcon = () => {
        switch(status) {
            case 'success':
                return <FaCheckCircle className={`${styles.dialogIcon} ${styles.successIcon}`} />;
            case 'error':
                return <FaTimesCircle className={`${styles.dialogIcon} ${styles.errorIcon}`} />;
            case 'loading':
                return <FaSpinner className={`${styles.dialogIcon}`} style={{ animation: 'spin 1s linear infinite' }} />;
            default:
                return null;
        }
    };

    const dialogTitles = {
        success: title || 'Message Sent Successfully!',
        error: title || 'Oops! Something Went Wrong',
        loading: 'Sending Message...'
    };

    const dialogMessages = {
        success: message || 'Your message has been sent. We\'ll get back to you soon.',
        error: message || 'There was an issue sending your message. Please try again.',
        loading: 'Please wait while we process your request.'
    };

    return (
        <div
            className={`${styles.dialogOverlay} ${isOpen ? styles.visible : ''}`}
            onClick={onClose}
        >
            <div
                className={styles.dialogContent}
                onClick={(e) => e.stopPropagation()}
            >
                {renderIcon()}

                <h2 className={styles.dialogTitle}>
                    {dialogTitles[status]}
                </h2>

                <p className={styles.dialogMessage}>
                    {dialogMessages[status]}
                </p>

                <div className={styles.dialogActions}>
                    {status !== 'loading' && (
                        <>
                            <button
                                className={`${styles.dialogButton} ${styles.primaryButton}`}
                                onClick={onClose}
                            >
                                Close
                            </button>
                            {status === 'error' && (
                                <button
                                    className={`${styles.dialogButton} ${styles.secondaryButton}`}
                                    onClick={onClose}
                                >
                                    Try Again
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SubmissionDialog;